/**
 * Payment Data Hook Constants
 * Centralized configuration for payment processing
 */

// Payment type configuration for display and ordering
export const PAYMENT_TYPE_CONFIG = {
	paymentOffers: { label: 'Finance', displayIndex: 0 },
	nationalOffers: { label: 'Finance', displayIndex: 0 },
	financeOffers: { label: 'Finance', displayIndex: 0 },
	leaseOffers: { label: 'Lease', displayIndex: 1 },
	cashOffers: { label: 'Cash', displayIndex: 2 }
};

// Deal type to offer key mapping
export const DEAL_TYPE_CONFIG = {
	finance: 'paymentOffers',
	lease: 'leaseOffers',
	cash: 'cashOffers'
};

// Default values
export const DEFAULT_DISPLAY_INDEX = 2;
export const DEFAULT_PAYMENT_TIMEOUT_MS = 10000;
export const DEFAULT_PAYMENT_VALUE = 0;

// Feature flag names
export const CACHE_PRELOAD_FLAG = 'ws-track-my-offer-preload-payment-data';
export const PAYMENT_OBJECT_FLAG = 'ws-track-my-offer-use-payment-object-update';
export const TIMEOUT_FLAG = 'ws-track-my-offer-uds-payment-timeout';
